export default __webpack_public_path__ + "static/media/KahshPay.8a3f9958.svg";